import { z } from "zod";
import { isPhoneComplete } from "@/shared/utils";

export const contactsSchema = z.object({
  email: z.string().email({ message: "validation.contacts.email_invalid" }),
  phone: z
    .string()
    .min(1, { message: "validation.contacts.phone_required" })
    .refine(isPhoneComplete, { message: "validation.contacts.phone_invalid" }),
  phone_additional: z
    .string()
    .optional()
    .or(z.literal(""))
    .refine((value) => !value || isPhoneComplete(value), { message: "validation.contacts.phone_invalid" }),
});

export type ContactsFormValues = z.infer<typeof contactsSchema>;
